import type { TFunction } from 'i18next';

/** Get translated certification label from type string */
export function getCertificationLabel(type: string | null | undefined, t: TFunction): string {
  if (!type) return t('teleportal.document.certification');
  const key = `teleportal.document.${type}`;
  const translated = t(key);
  return translated === key ? t('teleportal.document.certification') : translated;
}

/** What a task's document must carry, said by its certification ("Apostille required"). */
export function getCertificationRequirementLabel(
  type: string | null | undefined,
  t: TFunction
): string {
  return type ? getCertificationLabel(type, t) : t('teleportal.document.certificationRequired');
}

/** Calculate expiry info from a date string */
export function getExpiryInfo(expiryDate: string | null | undefined): {
  daysRemaining: number | null;
  isExpired: boolean;
  isExpiringSoon: boolean;
} {
  if (!expiryDate) return { daysRemaining: null, isExpired: false, isExpiringSoon: false };
  const days = Math.ceil((new Date(expiryDate).getTime() - Date.now()) / (1000 * 60 * 60 * 24));
  return { daysRemaining: days, isExpired: days <= 0, isExpiringSoon: days > 0 && days <= 30 };
}

/** Get location i18n label */
export function getLocationLabel(location: string | null | undefined, t: TFunction): string {
  const map: Record<string, string> = {
    home_country: t('teleportal.location.homeCountry'),
    target_country: t('teleportal.location.targetCountry'),
    online: t('teleportal.location.online'),
    either: t('teleportal.location.either'),
    home: t('teleportal.location.homeCountry'),
    target: t('teleportal.location.targetCountry'),
  };
  return location ? (map[location] ?? location) : '';
}
